// DropdownField.jsx
import React from "react";
import { Form } from "react-bootstrap";

const DropdownField = ({
  label,
  value,
  options,
  onChange,
  icon: Icon,
  multiple = false,
  optionLabelKey = "exName",
  optionValueKey = "id",
}) => {
  const handleChange = (e) => {
    if (multiple) {
      // Ensure values are parsed as numbers, consistent with original logic
      const selected = Array.from(
        e.target.selectedOptions, (opt) => parseInt(opt.value, 10)
      );
      onChange(selected); // send array for multi
    } else {
      onChange(e.target.value); // send single value
    }
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-medium d-flex align-items-center">
        {Icon && <Icon className="me-2" />}
        {label}
      </Form.Label>
      <Form.Select multiple={multiple} value={value ?? ''} onChange={handleChange}>
        {!multiple && <option value="">Select {label}</option>}
        {Array.isArray(options) && options.filter(Boolean).map((opt, idx) => {
          // Make component more robust by checking for common key patterns
          const itemValue = opt[optionValueKey] ?? opt.value;
          const itemLabel = opt[optionLabelKey] ?? opt.label;
          const key = itemValue ?? idx;

          // Do not render an option if it doesn't have a valid value
          if (itemValue === undefined || itemValue === null) return null;

          return (
            <option key={key} value={itemValue}>
              {itemLabel}
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>
  );
};

export default DropdownField;
